import React from "react";
import { Button } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { IMPORT_TYPES_CONFIG, } from "./importTypesConfig";
export var ImportTypeList = function (_a) {
    var selectedImport = _a.selectedImport, onSelectImport = _a.onSelectImport;
    return (React.createElement(React.Fragment, null, IMPORT_TYPES_CONFIG.map(function (importType) { return (React.createElement(Button, { key: importType.key, buttonStyle: selectedImport === importType.key ? "primary" : "default", fullWidth: true, onClick: function () { return onSelectImport(importType.key); } },
        React.createElement(FormattedMessage, { id: importType.translationKey }))); })));
};
